"use client"

import { useEffect, useState } from "react"
import { authService } from "@/services/auth"
import { Button } from "@/components/ui/button"
import { EyeOff } from "lucide-react"
import { motion } from "framer-motion"

export function ImpersonationOverlay() {
    const [isImpersonating, setIsImpersonating] = useState(false)
    const [userName, setUserName] = useState<string | null>(null);

    useEffect(() => {
        if (authService.isImpersonating()) {
            setIsImpersonating(true)
            authService.getCurrentUser().then(user => {
                setUserName(user.full_name || user.email);
            }).catch(() => {
                setUserName("User");
            });
        }
    }, [])

    const handleStopImpersonation = () => {
        authService.stopImpersonation()
    }

    if (!isImpersonating) return null

    return (
        <motion.div
            drag
            dragMomentum={false}
            whileHover={{ cursor: "grab" }}
            whileTap={{ cursor: "grabbing" }}
            className="fixed bottom-4 right-4 z-[100] flex items-center gap-4 rounded-lg bg-indigo-600 px-6 py-4 shadow-xl text-white animate-in slide-in-from-bottom border border-indigo-500 touch-none"
        >
            <div className="flex flex-col">
                <span className="font-bold text-sm uppercase tracking-wider flex items-center gap-2">
                    <span className="relative flex h-2 w-2">
                        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
                        <span className="relative inline-flex rounded-full h-2 w-2 bg-white"></span>
                    </span>
                    Impersonating
                </span>
                <span className="text-xs opacity-90">Viewing as {userName || "..."}</span>
            </div>
            <Button
                variant="secondary"
                size="sm"
                onClick={handleStopImpersonation}
                className="ml-2 bg-white text-indigo-600 hover:bg-indigo-50"
            >
                <EyeOff className="mr-2 h-4 w-4" />
                Stop
            </Button>
        </motion.div>
    )
}
